import { HTMLProps, ReactNode, useContext } from 'react';
import cx from 'classnames';

import { choosePaletteColor, getUserInitials } from 'utils';
import { imageSelector, isAuthSelector, nameSelector } from 'store/selectors';
import { useStore } from 'hooks';
import { Navbar } from 'containers';
import { Avatar } from 'components';
import { MenuIcon } from 'components/Icon';

import { layoutContext } from './Layout';

import styles from './Layout.module.scss';

export type LayoutHeaderProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  title?: string | ReactNode;
};

const LayoutHeader = ({ title, className }: LayoutHeaderProps): JSX.Element => {
  const { isAuth, image, name } = useStore(state => ({
    isAuth: isAuthSelector(state),
    name: nameSelector(state),
    image: imageSelector(state)
  }));

  const { openSidebar, openProfile } = useContext(layoutContext);

  const initials = getUserInitials(name);
  const fallbackColor = choosePaletteColor(initials);

  return (
    <Navbar
      className={cx(styles.header, className)}
      title={title}
      left={
        <button type="button" className={cx(styles.menu, styles.left)} onClick={openSidebar}>
          <MenuIcon />
        </button>
      }
      right={
        isAuth && (
          <button type="button" className={styles.profile} onClick={openProfile}>
            <Avatar className={styles.avatar} src={image} initials={initials} fallbackColor={fallbackColor} />
          </button>
        )
      }
    />
  );
};

export default LayoutHeader;
